import { dlTrackSorting } from 'app/analytics/productListAnalytics';
import { SELECT_SORTING } from './sortDropdownConstants';
import { fetchProducts } from '../productList/productListActions';

export const selectSorting = sortName => ({
  type: SELECT_SORTING,
  sortName,
});

export const onSortSelect = sortName => dispatch => {
  dlTrackSorting(sortName);
  dispatch(selectSorting(sortName));
  dispatch(fetchProducts({ showLoader: true, withAnalytics: true }));
};
